import { Input, Radio, RadioInputs } from "@deligoo/ui"
import { unwrapResult } from "@reduxjs/toolkit"
import { useState } from "react"
import { toast } from "react-toastify"

import { useAppDispatch, useAppSelector } from "@/App"
import { ConfirmModal } from "@/components/ConfirmModal"
import { requestCancelOrder } from "@/store/orders"
import { selectCurrentTeamId } from "@/store/teams"
import { Order } from "@/types"

type CancelOrderModalProps = {
  orderId: Order["id"]
  handleClose: () => void
}

export const CancelOrderModal = ({ orderId, handleClose }: CancelOrderModalProps) => {
  const team_id = useAppSelector(selectCurrentTeamId)

  const [cancellationReason, setCancellationReason] = useState("")
  const [withRefund, setWithRefund] = useState(false)

  const dispatch = useAppDispatch()

  async function handleCancelOrder() {
    if (!team_id) return

    const toastSettings = {
      toastId: "cancelOrder",
      updateId: "cancelOrder",
    }

    if (cancellationReason.length < 3) {
      toast.error("Powód anulowania jest zbyt krótki", toastSettings)
      return
    }

    const res = await dispatch(
      requestCancelOrder({
        orderId,
        body: {
          team_id,
          cancellation_reason: cancellationReason,
          with_refund: withRefund,
        },
      })
    ).then(unwrapResult)

    if (res.ok) {
      toast.success(`Zlecenie zostało anulowane.`, toastSettings)
    } else {
      toast.error(`Nie udało się anulować zlecenia. Spróbuj ponownie później.`, toastSettings)
    }

    handleClose()
  }

  return (
    <ConfirmModal title="Anuluj zlecenie" handleConfirm={handleCancelOrder} handleClose={handleClose}>
      <RadioInputs>
        <Radio
          color="success"
          onChange={(e) => setWithRefund(!e.currentTarget.checked)}
          name="order_refund"
          id="withRefund"
          defaultChecked
          required
        >
          Bez zwrotu
        </Radio>

        <Radio
          color="success"
          onChange={(e) => setWithRefund(e.currentTarget.checked)}
          name="order_refund"
          id="withoutRefund"
          required
        >
          Z zwrotem transakcji
        </Radio>
      </RadioInputs>

      <Input
        className="mt-6"
        placeholder="Powód anulowania"
        onChange={(e) => setCancellationReason(e.currentTarget.value)}
        plain
        required
        autoFocus
      />
    </ConfirmModal>
  )
}
